import { formatNumber } from './progression'
import type { Preferences } from './types'

export type UnitSystem = Preferences['unit']
const poundsPerKilogram = 2.2046226218

export const massUnit = (unit: UnitSystem) => unit === 'imperial' ? 'lb' : 'kg'
export const displayMass = (kilograms: number, unit: UnitSystem) => unit === 'imperial' ? kilograms * poundsPerKilogram : kilograms
export const storeMass = (value: number, unit: UnitSystem) => unit === 'imperial' ? value / poundsPerKilogram : value

export function massStep(kilogramIncrement: number, unit: UnitSystem) {
  if (unit === 'metric') return Math.max(.5, kilogramIncrement)
  const pounds = kilogramIncrement * poundsPerKilogram
  if (pounds < 3) return 2.5
  if (pounds < 8) return 5
  return 10
}

export const formatMass = (kilograms: number, unit: UnitSystem) => `${formatNumber(displayMass(kilograms, unit))} ${massUnit(unit)}`

export function formatTrainingVolume(kilogramReps: number, unit: UnitSystem) {
  if (unit === 'imperial') return `${formatNumber(displayMass(kilogramReps, unit))} lb`
  return kilogramReps >= 1000 ? `${formatNumber(kilogramReps / 1000)} t` : `${formatNumber(kilogramReps)} kg`
}
